export default "__VITE_ASSET__00082430__"